import { Badge } from '@synoptic/ui-kit/badge/badge.js';
import { IconButton } from '@synoptic/ui-kit/button/icon-button.js';
import { ShareAndroidIcon } from '@synoptic/ui-kit/icons/react/share-android.js';
import { XmarkIcon } from '@synoptic/ui-kit/icons/react/xmark.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@synoptic/ui-kit/tooltip/tooltip.js';
import { Stream } from '@/__generated__/schema-types';
import {
  badge,
  pillIcon,
  labelContent,
  pillRemove,
} from './typeahead-multiselect.css';

export const StreamPill = ({
  stream,
  onRemove,
  incompatible = false,
}: {
  stream: Stream;
  onRemove?: (e: React.MouseEvent) => void;
  /** Kept in a matching list but without market matching of its own. */
  incompatible?: boolean;
}) => {
  return (
    <Tooltip delayDuration={600} disableHoverableContent>
      <TooltipTrigger asChild>
        <Badge
          className={badge}
          color={incompatible ? 'auxLightOrange' : 'auxLightBlue'}
          data-testid="stream-badge"
          data-incompatible={incompatible ? '' : undefined}
        >
          <ShareAndroidIcon className={pillIcon} />

          <span className={labelContent}>{stream.name}</span>
          {onRemove && (
            <IconButton
              onClick={onRemove}
              variant="ghost"
              size="xSmall"
              className={pillRemove}
            >
              <XmarkIcon color={themeVars.badge.foreground.default} />
            </IconButton>
          )}
        </Badge>
      </TooltipTrigger>
      <TooltipContent
        description={
          incompatible
            ? `${stream.name} — no market matching, remove it or turn off "Matching streams only"`
            : stream.name
        }
      />
    </Tooltip>
  );
};
